import { render, staticRenderFns } from "./MiniKaskoOrderHeader.vue?vue&type=template&id=54153fa8&scoped=true&"
import script from "./MiniKaskoOrderHeader.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoOrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoOrderHeader.vue?vue&type=style&index=0&id=54153fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54153fa8",
  null
  
)

export default component.exports